import { useState, useEffect } from 'react';
import { RelationFieldType } from 'src/Types/Form';
import { EnumItemType, EnumsType } from "../";
import API from 'src/API';
import { SimpleSelect } from '@redoc/ui-kit';

export interface RelationFieldProps extends React.HTMLAttributes<HTMLDivElement>  {
	
	isPlaceholder?: boolean;
	placeholder?: string;
	disabled?: boolean;
	searchEnable?: boolean;
	showClearBtn?: boolean;

	value?: string|Array<string>;
	setValue?: React.Dispatch<React.SetStateAction<string|Array<string>>>;
	onClear?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;

	onClose?: () => void;
	onStateChange?: ( type: string, props: any ) => void;

	minSearchLength?: number;
	onSearch?: ( tern: string ) => void;

	relation: RelationFieldType;
	onPrepareData?: ( result: any ) => EnumsType;

	multiple?: boolean;
	defaultOpen?: boolean;
	isOwnerList?: boolean;
	isBlockArrow?: boolean;
	isPortal?: boolean;
};

/** Компонента выпадающего списка с серверным запросом опций */
const RelationField: React.FC<RelationFieldProps> = (props) => {
	
	const { relation, onPrepareData, value, minSearchLength = 3 } = props;

	const [ isWait, setIsWait ] = useState<boolean>(false);
	const [ data, setData ] = useState<EnumsType>([]);
	const [ search, setSearch ] = useState<string>('');

	useEffect( () => {
		loadOptions(search);
	// eslint-disable-next-line
	}, [ search ] );

	/** Функция получения списка опций */
	const loadOptions = ( searchText: string ) => {
		setIsWait(true);
		const adddata = relation.onPrepareRequestData ? relation.onPrepareRequestData() : null;
		API.getFilterValues(relation.method, relation.url, searchText, 0, 100, value, adddata )
			.then( result => {
				if ( !result?.hasError ) {
					const prepared = !!onPrepareData ? onPrepareData : prepareEnumData;
					// Тут аццкий говонокод( костыль для отображения ранее выбранных значений при фильтрации 
					setData( prev => {
						const list = prepared(result, relation);
						if ( value && !list.filter( op => isSelectedOption(op,value)).length ) {
							const selectedOptions = prev.filter( op => isSelectedOption( op, value ) );
							list.push( ...selectedOptions );
						}
						return list;
					});
				}
			})
			.catch( (e: any) => {
				console.warn(e);
			})
			.finally( () => setIsWait(false) );
	};

	const onSearchHandler = ( text: string ) => setSearch(text);

	const setValueHandler = (val: string|number|Array<string|number>) => {
		if ( !!props.setValue ) {
			const stringValue = Array.isArray(val) 
				? val.map(v => String(v)) 
				: String(val);
			props.setValue(stringValue as string|Array<string>);
		}
	};

	return (
		<SimpleSelect
			{...props}
			setValue={setValueHandler}
			options={data}
			isWait={isWait}
			onSearch={ relation.serverSideSearch ? onSearchHandler : undefined }
			searchEnable={relation.serverSideSearch}
			minSearchLength={minSearchLength}
		/>
	);
};

/** Возвращает ИД опции */
const getIdOption = ( option: EnumItemType ): string => ( typeof option === "object" && option?.id ) ? option.id.toString() : option.toString();

/** Функция проверки опции на признак выбраности */
const isSelectedOption = ( option: EnumItemType, values: string|string[] ): boolean => {
	if ( Array.isArray( values ) ) {
		return values.includes( getIdOption( option ) );
	}
	else
		return getIdOption( option ) === values;
};

const prepareEnumData = ( data: any = [], relation: RelationFieldType ): EnumsType => data.map( (item: any) => ({
	id: item[relation.valueKey],
	title: !!relation.titleKey ? item[relation.titleKey] : item[relation.valueKey]
}) );

export default RelationField;
